function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12636.9,1482.96a0.972,0.972,0,0,0-1,1v6.4h-13.4V1469h13.4v6.42a0.966,0.966,0,0,0,1,1,1.03,1.03,0,0,0,1-1v-6.92a1.517,1.517,0,0,0-1.5-1.5H12622a1.517,1.517,0,0,0-1.5,1.5v22.36a1.517,1.517,0,0,0,1.5,1.5h14.4a1.517,1.517,0,0,0,1.5-1.5v-6.9A1.037,1.037,0,0,0,12636.9,1482.96Zm7.9-4.17-4.3-4.41a0.983,0.983,0,0,0-1.4-.01,1.1,1.1,0,0,0-.1,1.42l2.7,2.7H12627a1,1,0,0,0,0,2h14.7l-2.7,2.71a1.217,1.217,0,0,0,0,1.41,1.135,1.135,0,0,0,.8.3,1.08,1.08,0,0,0,.7-0.3l4.3-4.4A0.99,0.99,0,0,0,12644.8,1478.79Z",
  transform: "translate(-12620.5 -1467)"
});

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.6,
    height: 25.38,
    viewBox: "0 0 24.6 25.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c31d8e31.svg";
export { ForwardRef as ReactComponent };